import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import desktopLogoBlack from "../../src/assets/images/logo_black.png";
import "@fortawesome/fontawesome-svg-core/styles.css"; // Import the Font Awesome CSS
import { config } from "@fortawesome/fontawesome-svg-core";
import Cookies from "js-cookie";
import { useUserLoginMutation } from "../services/useUserLoginMutation";
import { toast } from "react-toastify";
config.autoAddCss = false;

const LoginPage = () => {
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const { mutateAsync: login, isLoading: loginLoading } =
    useUserLoginMutation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onSubmit = async (formData) => {
    setLoginError("");
    try {
      const res = await login(formData);

      if (res && res.success) {
        const successMessage = res?.message || "success";
        let data = res?.data?.data;

        Cookies.set("token", data.login_token, { expires: 7 });
        Cookies.set("user", JSON.stringify(data), { expires: 7 });
        // toast.success(successMessage);
        reset();
        navigate("/");
      } else {
        const errorMessage = res?.message || "failed";
        setLoginError(errorMessage);
        toast.error(errorMessage);
        reset();
      }
    } catch (error) {
      console.error("Login failed with error:", error);
      setLoginError(error.message || "failed");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#cfc9ff33]">
      <div className="max-w-lg w-full p-6 bg-white rounded-lg shadow-md  2xl:max-w-xl  ">
        <div className="mb-2 flex justify-center">
          <img
            src={desktopLogoBlack}
            alt="desktop logo"
            className="cursor-pointer w-full h-auto object-contain"
            style={{ maxHeight: "120px" }}
          />
        </div>
        <div className="mb-6 text-left">
          <h2 className="text-2xl font-semibold mb-2">Welcome to Qualiphy</h2>
          <p className="text-lg text-gray-400">Please enter your details</p>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.email ? "border-red-500" : ""
              }`}
              placeholder="Email"
              {...register("email", { required: "Email is required" })}
            />
            {errors.email && (
              <p className="text-red-500 text-xs italic">
                {errors.email?.message}
              </p>
            )}
          </div>

          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.password ? "border-red-500" : ""
                }`}
                placeholder="Password"
                {...register("password", { required: "Password is required" })}
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 px-3 flex items-center focus:outline-none"
                onClick={togglePasswordVisibility}
              >
                <FontAwesomeIcon
                  icon={showPassword ? faEyeSlash : faEye}
                  className="text-gray-500 hover:text-gray-700"
                />
              </button>
            </div>
            {errors.password && (
              <p className="text-red-500 text-xs italic">
                {errors.password?.message}
              </p>
            )}
          </div>

          <div className="flex w-full items-center justify-end mb-2">
            <Link
              to="/forgot-password"
              className="text-[#8058FA] hover:text-[#6344c7] focus:outline-none"
            >
              Forgot password?
            </Link>
          </div>

          <div className="mb-4">
            <button
              type="submit"
              disabled={loginLoading}
              className={`bg-[#8058FA] hover:bg-[#6344c7] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full ${
                loginLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {loginLoading ? "Logging In..." : "Login"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
